<template>
  <div>
    <div v-if="isSearchOpen" class="overlay"></div>
    <section id="header-list-search" :class="{ searchActive: isSearchOpen }" class="mb-5">
      <b-container class="search-inputs-wrapper p-0">
        <search-online class="d-block"
                       :showResults="true"
                       :definedSearch="searchi18n"
                       :definedLocation="location"
                       :isSearchPage="true"
                       :geoLocation="geoLocation"
                       v-on:searchResults="getSearchResults"
                       @openSearch="openSearch"></search-online>
      </b-container>
    </section>

    <b-container class="main-container">
      <div v-if="isSearchLoading">
        <preloader :title="$t('preloader.searchingPros')"></preloader>
      </div>
      <div v-else-if="!_.isEmpty(searchResults)" class="search-results-container">

        <b-container>
          <div id="search-results-list">
            <b-row class="professionals-list">
              <b-col v-if="!_.isEmpty(searchResultsBoosted)"
                     cols="12"
                     md="6"
                     v-for="(boosted, index) in searchResultsBoosted"
                     :key="`boosted-${index}`">
                <router-link class="search-result-item boosted"
                             @click.native="incAdClicks(boosted.id, 'search')"
                             :to="{ name: `OnlineProfessionalsSingle.${$i18n.i18next.language}`, params: { slug: boosted.slug, section: 'online' } }">
                  <div class="ad-label"><span>{{ $t('marketing.paidSearch.adLabel') }}</span></div>
                  <online-search-result :result="boosted"></online-search-result>
                </router-link>
              </b-col>

              <b-col cols="12"
                     md="6"
                     v-for="(result, index) in searchResultsComp"
                     :key="`result-${index}`">
                <div v-if="!_.isEmpty(searchAds) && result === 'ad'">
                  <ad training="online" page="search"></ad>
                </div>
                <router-link v-else
                             class="search-result-item"
                             :class="{ active: hasMarker(result.locations) }"
                             @mouseover.native="handleResultMouseOver(result.locations)"
                             @mouseleave.native="handleResultMouseLeave"
                             :to="{ name: `OnlineProfessionalsSingle.${$i18n.i18next.language}`, params: { slug: result.slug, section: 'online' } }">
                  <online-search-result :result="result"></online-search-result>
                </router-link>
              </b-col>
            </b-row>
          </div>
        </b-container>
      </div>
      <b-row v-else class="mt-3">
        <b-col>
          - {{ $t('searchPage.emptySearch') }} -
        </b-col>
      </b-row>

    </b-container>

  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import { DEBOUNCE_TIMER } from '@/util/constants'

  /* Start of lazy load components config */
  import lazyLoadComponent from '@/util/lazy-load-component'
  import Preloader from '@/app/global/components/Preloader'
  // import SkeletonBox from '@/app/global/components/SkeletonBox'
  const lazyLoadOptions = {
    loading: Preloader,
    loadingData: {
      props: {
        width: '100%',
        height: '2rem'
      }
    }
  }
  /* End of lazy load components config */

  export default {
    name: 'online-professionals-list',
    components: {
      SearchOnline: lazyLoadComponent({...lazyLoadOptions, componentFactory: () => import('@/app/global/components/SearchOnline')}),
      GoogleMap: lazyLoadComponent({...lazyLoadOptions, componentFactory: () => import('@/app/global/components/GoogleMapSearch')}),
      Ratings: lazyLoadComponent({...lazyLoadOptions, componentFactory: () => import('@/app/global/components/Ratings')}),
      Autocomplete: lazyLoadComponent({...lazyLoadOptions, componentFactory: () => import('@/app/global/components/Autocomplete')}),
      Ad: lazyLoadComponent({...lazyLoadOptions, componentFactory: () => import('./Ad')}),
      OnlineSearchResult: lazyLoadComponent({...lazyLoadOptions, componentFactory: () => import('./OnlineSearchResult')})
    },
    data () {
      return {
        errors: {},
        results: [],
        location: this.$i18n.t('placeholders.defaultLocation'),
        locationLat: '',
        locationLng: '',
        search: '',
        searchi18n: '',
        searchSpecific: '',
        showPopover: false,
        isResultsLoading: false,
        isOpen: false,
        servicesResults: [],
        servicesResultsi18n: [],
        specialitiesResults: [],
        specialitiesResultsi18n: [],
        isLoading: false,
        arrowCounter: -1,
        globalCount: 0,
        placesActive: [],
        clickedMarker: {},
        hiddenMobile: true,
        isSearchOpen: false,
        geoLocation: {
          formatted: '',
          coords: {}
        }
      }
    },
    computed: {
      ...mapGetters({
        user: 'account/user',
        authenticated: 'account/authenticated',
        servicesObject: 'account/services',
        specialitiesObject: 'account/specialities',
        searchResults: 'professionals/onlineSearchResults',
        searchNamesResults: 'professionals/onlineSearchNamesResults',
        searchResultsBoosted: 'professionals/onlineSearchResultsBoosted',
        searchAds: 'professionals/onlineSearchResultsAds',
        isSearchLoading: 'professionals/isSearchLoading'
      }),
      searchResultsComp () {
        let arr = _.cloneDeep(this.searchResults)
        if (!_.isEmpty(this.searchAds)) {
          if (arr.length > 3 && !_.isEmpty(this.searchAds)) {
            arr.splice(2, 0, 'ad');
          }

          if (arr.length > 8 && !_.isEmpty(this.searchAds)) {
            arr.splice(7, 0, 'ad');
          }

          if (arr.length > 13 && !_.isEmpty(this.searchAds)) {
            arr.splice(12, 0, 'ad');
          }

          if (arr.length > 18 && !_.isEmpty(this.searchAds)) {
            arr.splice(17, 0, 'ad');
          }
        }
        return arr
      },
      locations: function () {
        if (!_.isEmpty(this.searchResults)) {
          let locations = _.map(this.searchResults, 'locations')
          let result = {
            places: []
          }

          if (!_.isUndefined(locations) && locations.length > 0) {
            for (let i = 0; i < locations.length; i++) {
              // result = _.unionBy(locations[i], result, 'places')
              // result.places = locations[i]['places']

              if (!_.isUndefined(locations[i])) {
                if (!_.isUndefined(locations[i]['places']) && locations[i]['places'].length > 0) {
                  for (let j = 0; j < locations[i]['places'].length; j++) {

                    let user = {
                      first_name: this.searchResults[i].first_name,
                      last_name: this.searchResults[i].last_name,
                      image: this.searchResults[i].image,
                      slug: this.searchResults[i].slug,
                      specialities: this.searchResults[i].full_text_specialities_en
                    }
                    let place = locations[i]['places'][j]
                    let existingIndex = _.findIndex(result.places, {'coords': [place.coords.lat, place.coords.lon]})

                    // Place already exists, do not push this place to array
                    if (existingIndex > -1) {
                      // If users array for this place already exists
                      if (!_.isUndefined(result.places[existingIndex].users)) {
                        result.places[existingIndex].users.push(user)
                      } else {
                        result.places[existingIndex].users = []
                        result.places[existingIndex].users.push(user)
                      }
                    } else {
                      // Place is new, let's add users array to it with current user that is located in this place
                      place.users = []
                      place.users.push(user)
                      result.places.push(place)
                    }
                  }
                }
              }
            }
          }
          // result.places = _.uniqBy(result.places, 'formatted_address')
          result.places = _.uniqBy(result.places, v => [v.coords.lat, v.coords.lon].join())
          result.placesActive = this.placesActive
          return result
        }
        return []
      }
    },
    methods: {
      ...mapActions({
        incCampaignClicks: 'professionals/incOnlineCampaignClicks'
      }),
      getSearchResults (results) {
        // this.results = results
      },
      handleResultMouseOver: function (locations) {
        if (!_.isUndefined(locations.places) && locations.places.length > 0) {
          let places = locations.places
          this.placesActive = places
        }
      },
      handleResultMouseLeave: function () {
        this.placesActive = []
      },
      markerClick: function (marker) {
        if (!_.isUndefined(marker)) {
          this.clickedMarker = marker.position
        }
      },
      markerClickOutside: function (event) {
        // Disable click on Google maps area
        if (event.target.localName !== 'area') {
          this.clickedMarker = {}
        }
      },
      hasMarker: function (locations) {
        if (!_.isUndefined(locations)) {
          if (!_.isUndefined(locations.places) && locations.places.length > 0 && !_.isEmpty(this.clickedMarker)) {
            if (!_.isEmpty(_.find(locations.places, this.clickedMarker))) {
              return true
            }
          }
        }
        return false
      },
      showMap: function () {
        this.hiddenMobile = false
      },
      hideMap: function () {
        this.hiddenMobile = true
      },
      openSearch: function (isOpen) {
        this.isSearchOpen = isOpen
      },
      formatServices: function (services) {
        let res = services.split('. ').join('<br />')

        return res
      },
      geoLocate (formatted, coords) {
        this.geoLocation.formatted = formatted
        this.geoLocation.coords = {
          lat: coords[0],
          lng: coords[1]
        }
      },
      incAdClicks (id, type) {
        let payload = {
          id: id,
          type: type,
          training: 'online'
        }
        this.incCampaignClicks({ payload: payload })
      },
      truncate (str, n, useWordBoundary) {
        if (str.length <= n) {
          return str
        }
        var subString = str.substr(0, n-1)
        return (useWordBoundary
          ? subString.substr(0, subString.lastIndexOf(' '))
          : subString) + "&hellip;";
      }
    },
    created () {

    },
    mounted: function () {
      this.$el.addEventListener('click', this.markerClickOutside)
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>


  .overlay {
    @include media-breakpoint-down(sm) {
      position: fixed;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      width: 100%;
      height: 100vh;
      background: rgba(0,0,0,0.5);
      z-index: 10;
    }
  }

  #header-list-search {
    position: relative;
    background: #f5f5f5;
    padding: 1rem;

    .search-inputs-wrapper {
    }

    &.searchActive {
      @include media-breakpoint-down(sm) {
        position: unset;
      }

      .search-inputs-wrapper {
        min-width: 320px;

        @include media-breakpoint-down(sm) {
          position: fixed;
          top: 4rem;
          left: 0;
          right: 0;
          width: 100%;
          z-index: 11;

          .intro {
            display: none;
          }
        }
      }
    }
  }

  .main-container {
    /*height: calc(100vh - 200px);

    @include media-breakpoint-down(sm) {
      position: absolute;
      max-width: 100%;
      height: 100%;
      overflow: hidden;
      background: white;
      z-index: 9;
    }*/
  }

  h1, h2 {
    font-weight: normal;
  }
  ul {
    list-style-type: none;
    padding: 0;
  }
  li {
    display: inline-block;
    margin: 0 10px;
  }
  a {
    color: inherit;
    text-decoration: none;

    &:hover {
      text-decoration: none;
    }
  }

  span.highlight {
    background-color: yellow;
  }

  .search-input-wrapper {
    position: relative;
    &.form-control {
      padding: 0;
      border: none;
    }

    @include media-breakpoint-down(sm) {
      position: unset !important;
    }
  }

  #popover {
    display: none;

    &.show {
      display: block;
      position: absolute;
      width: 100%;
      min-height: 350px;
      background: white;
      z-index: 900;
    }

    h3.header {
      margin-top: 0;
      padding: 0.5rem 0.75rem;
      margin-bottom: 0;
      font-size: 1rem;
      color: inherit;
      background-color: #f7f7f7;
      border-bottom: 1px solid #ebebeb;
      border-top-left-radius: calc(0.3rem - 1px);
      border-top-right-radius: calc(0.3rem - 1px);
      text-align: left;

      .btn.close {
        background: transparent;
      }
    }

    .dropdown-menu {
      &.show {
        max-height: 250px;
        overflow-y: scroll;
      }
    }

    .btn-group {
      display: block;
      text-align: left;
      margin: 0 !important;

      .btn.dropdown-toggle {
        text-align: left;
        padding-right: 1rem;

        &:after {

        }
      }
    }
  }


  .search-results-container {

    .container {
      height: 100%;
    }

    @include media-breakpoint-down(md) {
      position: relative;
      top: unset;
      margin-bottom: 0;
      overflow: visible;

      .container {
        max-width: 100%;
      }
    }
  }

  #search-results-list {
    position: relative;
    height: 100%;

    .matches {
      font-size: 0.7rem;
    }

    .search-result-item {
      display: block;
      padding: 0;
      border: 1px solid #ddd;
      margin-bottom: 1rem;

      &.active,
      &:hover {
        border-color: #6ecdff;

        button.cta {
          color: white;
          border-color: #6ecdff;
          background: #6ecdff;
        }
      }

      &.boosted,
      &.ad {
        position: relative;
        border-color: #6ecdff;
        word-break: break-word;

        .ad-label {
          position: absolute;
          right: 0;
          bottom: 0;
          width: 0;
          height: 0;
          border-left: 60px solid transparent;
          border-bottom: 60px solid #6ecdff;
          z-index: 2;

          span {
            position: absolute;
            right: -5px;
            bottom: -49px;
            color: #fff;
            text-align: center;
            width: 3rem;
            font-size: .8rem;
            transform: rotate(-45deg);
            -webkit-transform: rotate(-45deg);
            -moz-transform: rotate(-45deg);
            -ms-transform: rotate(-45deg);
            -o-transform: rotate(-45deg);
            filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=3);
          }
        }
      }
      &.ad {
        border-color: #00e2ff;

        .ad-label {
          border-bottom: 60px solid #00e2ff;
        }

        img {
          width: 150px;
          height: auto;
        }

        &:hover {
          border-color: #00e2ff;

          button.cta {
            color: white;
            border-color: #00e2ff;
            background: #00e2ff;
          }
        }
      }
    }

    @include media-breakpoint-down(sm) {
      height: 100%;
    }
  }

  .professionals-list {
    height: 100%;
    overflow-y: auto;
    overflow-x: hidden;

    a {
      color: black !important;
    }

    @include media-breakpoint-down(sm) {

    }
  }

  .autocomplete {
    position: relative;
    width: 100%;

    #search-services {
      padding-right: 2.5rem;
    }

    @include media-breakpoint-down(sm) {
      position: unset !important;
    }
  }

  .autocomplete-results {
    position: absolute;
    top: 2.5rem;
    left: 0;
    padding: 0;
    margin: 0;
    height: auto;
    overflow: auto;
    width: 50%;
    z-index: 999;

    &.autocomplete-specialities {
      left: 0;
      width: 50%;
    }

    &.autocomplete-services {
      left: 50%;
      width: 100%;

      @include media-breakpoint-down(sm) {
        width: 50%;
      }
    }

    &.autocomplete-professionals {
      left: 0%;
      width: 100%;

      a {
        color: inherit !important;
      }
    }

    .wrapper {
      height: auto;
      max-height: 400px;
      overflow-y: scroll;
      border: 1px solid #eeeeee;
      background: white;

      @include media-breakpoint-down(sm) {
        height: 100vh;
      }
    }
  }

  .autocomplete-result {
    width: 100%;
    list-style: none;
    text-align: left;
    padding: 4px 2px;
    cursor: pointer;
  }

  #services-list {
    .card {
      border: none;
      border-radius: 0;
    }
    header {
      padding: 0;
      background: transparent;
      border: none;
      border-radius: 0;
    }
    .btn.main-level {
      color: inherit;
      white-space: normal;
      border: none;
      border-radius: 0;
      border-bottom: 2px solid black;
      text-align: left;
      box-shadow: none;
      background: transparent;
    }
    .btn.second-level {
      color: white;
      border: none;
      box-shadow: none;
    }
    .card-body.third-level {
      padding: 0.5rem 0;

      a.third-level {
        display: block;
        color: black;
        padding: 0.5rem 0;
        border-bottom: 1px solid black;
        white-space: normal;
      }
    }
  }

  .autocomplete-result.is-active,
  .autocomplete-result:hover {
    background-color: #4aae9b;
    color: white;
  }

  #search {
    position: relative;
  }

  #search-input {
    .btn.services-list {
      position: absolute;
      right: 0.1rem;
      top: 0.4rem;
      background: transparent;
      margin: 0;
      padding: 0;
      border: 0;
      text-align: center;
      vertical-align: middle;
      z-index: 99;

      i {
        color: #ccc;
      }

      @include media-breakpoint-down(sm) {
        display: none;
      }
    }
  }

  .map-container {
    display: block;
    /*position: absolute;*/
    /*top: 0;*/
    /*right: 0;*/
    /*bottom: 0;*/
    .map {
      height: 100%;
      width: 100%;
      display: flex;
      flex-direction: column;
      #gmap {
        position: relative;
        height: auto;
        flex: 1 1 50%;
        display: flex;
        justify-content: center;
        flex-grow: 1;
        flex-shrink: 1;
      }

      @include media-breakpoint-down(sm) {
        height: 100vh;
      }
    }

    &.hiddenMobile {
      @include media-breakpoint-down(sm) {
        display: none;
      }
    }

    @include media-breakpoint-down(sm) {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      z-index: 9;
    }
  }

</style>
